import React from "react";
import { Link } from "react-router-dom";
import SEO from "../../components/SEO";
import { FreeOnlineVideoChatBanner, SROnlyH1 } from "./Banners";
import FAQSection from "../../components/FAQSection";
import "./landing.css";

export default function FreeOnlineVideoChat() {
  return (
    <>
      <SEO
        title="Free Online Video Chat - Talkvee"
        description="Free online video chat that’s fun and simple. Guest login in seconds, icebreakers, and trivia challenges."
        pathname="/free-online-video-chat"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://talkvee.com" },
            { "@type": "ListItem", "position": 2, "name": "Free Online Video Chat", "item": "https://talkvee.com/free-online-video-chat" }
          ]
        }}
      />

      <div className="landing-wrapper">
        <FreeOnlineVideoChatBanner />
        <section className="landing-hero">
          
          <h1 className="landing-title">Free Online Video Chat — No Ads, Just People</h1>
          <p className="landing-subtitle">
            Join as a guest in seconds and meet new people. Interest matching and
            quick games make it easy to start talking.
          </p>
          <Link to="/" className="tv-cta">🚀 Start Chatting on Talkvee</Link>
        </section>

        <FAQSection
          items={[
            {
              q: "Is Talkvee really free?",
              a: "Yes. Talkvee is 100% free, with no ads, no hidden fees, and no subscriptions."
            },
            {
              q: "Why is Talkvee free?",
              a: "Because we want a fun, safe space for real connections, not profit-driven ads or tracking."
            },
            {
              q: "Do I need to create an account?",
              a: "No. You can join as a guest instantly. Social login is optional."
            },
            {
              q: "What makes Talkvee fun compared to other sites?",
              a: "Talkvee includes trivia games, laugh challenges, and soon VeeClips — features designed to make chats lively."
            },
            {
              q: "How is Talkvee different from other free video chat apps?",
              a: "Unlike many, Talkvee is lightweight, safe, ad-free, and community-driven."
            },
            {
              q: "Does it work on my phone?",
              a: "Yes. You can use Talkvee in your mobile browser or install it as a PWA."
            },
            {
              q: "What if someone breaks the rules?",
              a: "You can report them. Repeat offenders are banned to keep the community respectful."
            }
          ]}
        />

      </div>
    </>
  );
}